import React from 'react';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import FilterForm from '../../../../../components/form/base/FilterForm';
import TextField from '../../../../../components/form/elements/TextField';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../../../components/form/enum/formProps';
import { MultimediaFilterValues } from '../../../model/multimediaModel';
import * as Actions from '../../../redux/multimediaActions';
import useDataGridProgressContext from '../../../../../components/progress/DataGridProgress/context/DataGridProgressContext';

const initialValues: MultimediaFilterValues = {
  name: '',
};

const validationSchema = Yup.object().shape({
  name: Yup.string().min(2, 'validation.too_short').max(120, 'validation.too_long'),
});

const MultimediaFilter: React.FC = () => {
  const dispatch = useDispatch();
  const dataGridProgressContext = useDataGridProgressContext();

  return (
    <FilterForm<MultimediaFilterValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: MultimediaFilterValues) => {
        dataGridProgressContext.show();
        dispatch(Actions.getAllMultimedia(values));
      }}
      disabled={dataGridProgressContext.visibility}
    >
      <TextField
        name="name"
        label="multimedia.name"
        type={TEXT_FIELD_TYPE.TEXT}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
    </FilterForm>
  );
};

export default MultimediaFilter;
